import { Provider, Sanitizer } from '@angular/core';
import { NgDompurifySanitizer } from '@tinkoff/ng-dompurify';

export const provideSanitizer: Provider = {
    provide: Sanitizer,
    useClass: NgDompurifySanitizer
};
